export const INVALID_EMAIL = "Invalid email";
export const INVALID_OTP = "Invalid otp";
export const INVALID_PHONE = "Invalid Phone Number";
export const REQUIRED_FIELD = "Required";
export const MIN_LENGTH_PWD =
  "Password is too short - should be 6 chars minimum.";
export const MAX_LENGTH_CODE = "Gift code should be maxiumn of 12 characters";
export const SUCCESS = "Success";
export const INVALID = "Invalid";
